module.exports = __webpack_public_path__ + "greenlotusdots.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/greenlotusdots.png
// module id = 880
// module chunks = 0